import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", ";\n    font-family: ", ";\n    font-stretch: ", ";\n    line-height: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/* eslint-disable-next-line import/named */
import { css } from 'styled-components';
export var injectTypography = function injectTypography(_ref, variant) {
  var theme = _ref.theme;

  var _ref2 = theme.responsive.typography[variant] || {},
      fontFamily = _ref2.fontFamily,
      fontSize = _ref2.fontSize,
      fontStretch = _ref2.fontStretch,
      lineHeight = _ref2.lineHeight;

  return css(_templateObject(), fontSize ? "var(".concat(fontSize, ")") : undefined, fontFamily ? "var(".concat(fontFamily, ")") : undefined, fontStretch ? "var(".concat(fontStretch, ")") : undefined, lineHeight ? "var(".concat(lineHeight, ")") : undefined);
};